import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core"
import { UserService } from "../../services/user.service"
import { Params, QueryParamsHandling } from "@angular/router"

@Component({
    selector: "app-link",
    templateUrl: "./link.component.html",
    styleUrls: ["link.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class LinkComponent implements OnInit {
    @Input() href = null
    @Input() appRouterLink: any[] | string | null | undefined = null
    @Input() queryParams: Params
    @Input() routerLinkActive: string[] | string = ""
    @Input() queryParamsHandling: QueryParamsHandling = null
    @Input() title: string = ""
    @Input() target: string = ""
    @Input() badgeCount: number = 0
    @Input() linkClasses?: string = ""

    constructor(private userService: UserService) {}

    public ngOnInit() {
        const params = this.userService.getStudentQueryParams()
        if (Object.keys(params).length !== 0) {
            if (this.appRouterLink) {
                this.queryParams = {
                    ...this.queryParams,
                    ...params,
                }
            } else if (this.href) {
                this.href += this.href.includes("?") ? "&student=true" : "?student=true"
            }
        }
    }
}
